export default "__VITE_ASSET__D20r7p7X__"